import { GeolocationFormModal } from '../GeolocationForm/GeolocationForm';
import { GeolocationsDataGrid } from './GeolocationsDataGrid';

export function GeolocationManagementScreen() {
  return (
    <>
      <GeolocationsDataGrid />
      <GeolocationFormModal />
    </>
  );
}
